<template>
  <Select
    v-model="selectedCategory"
    @onSelect="onSelect"
    @onClear="onClear"
    :options="getOptions"
    :title="getPlaceholder"
    :placeholder="getPlaceholder"
    v-readonly
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>
<script>
import Select from '../../../../components/Select';

const flatten = (arr, formatArr, parent) => arr.reduce((flat, toFlatten) => {
  const paths = [
    ...(parent.paths || []),
    ...[toFlatten.Name],
  ];
  const ids = [
    ...(parent.ids || []),
    ...[toFlatten.Id],
  ];

  if (!toFlatten.Nodes || toFlatten.Nodes.length <= 0) {
    formatArr.push({
      value: toFlatten.Id,
      label: toFlatten.Name,
      Id: toFlatten.Id,
      Name: toFlatten.Name,
      path: paths.join(' > '),
      ids: ids,
      paths,
      values: ids,
    });
    return formatArr;
  }

  toFlatten.path = paths.join(' > ');
  toFlatten.paths = paths;
  toFlatten.ids = ids;

  return flatten(toFlatten.Nodes, formatArr, toFlatten);
}, []);

export default {
  name: 'CategorySelect',
  components: { Select },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    options: {
      type: Array,
      default: () => ([]),
    },
    relatedCategories: {
      type: Array,
      default: () => ([]),
    },
  },
  data () {
    return {
      categories: [],
      category: {},
    };
  },
  computed: {
    getOptions () {
      return this.categories;
    },
    getPlaceholder () {
      return this.$attrs.placeholder || 'Ekleyeceğiniz ürünün kategorisiniz seçiniz';
    },
    selectedCategory: {
      get () {
        return this.value;
      },
      set (val) {
        return val;
      },
    },
  },
  methods: {
    onSelect (option) {
      this.$emit('input', option);
    },
    onClear () {
      this.$emit('input', {});
    },
  },
  watch: {
    options: {
      handler (val) {
        if (val && val.length > 0) {
          const flattenCategories = flatten(val, [], {});
          this.categories = flattenCategories
            .filter(category => this.relatedCategories.indexOf(category.Id) > -1)
            .map(category => ({
              label: category.Name,
              id: category.Id,
            }));
        }
      },
      immediate: true,
    },
  },
};
</script>
